import { createSlice } from "@reduxjs/toolkit";
import { chatOrder, chatProduct, chatVoucher, createChatConfig } from "./thunk";

interface ChatState {
  loading: boolean;
  data: any[];
  error: string | null;
}

const initialState: ChatState = {
  loading: false,
  data: [],
  error: null,
};

const chatsSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createChatConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createChatConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data.push(action.payload);
      })
      .addCase(createChatConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = "Chat send failed";
      })
      .addCase(chatOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(chatOrder.fulfilled, (state:any, action) => {
        state.loading = false;
        state.orderChat = action.payload;
      })
      .addCase(chatOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(chatProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(chatProduct.fulfilled, (state:any, action) => {
        state.loading = false;
        state.orderProduct = action.payload.data;
      })
      .addCase(chatProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(chatVoucher.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(chatVoucher.fulfilled, (state:any, action) => {
        state.loading = false;
        state.orderVoucher = action.payload;
      })
      .addCase(chatVoucher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default chatsSlice.reducer;
